import CustomBanner from "@components/CustomBanner";
import { Head } from "vite-react-ssg";
import BannerImage from "@assets/images/Web-App-Portal.avif";
import { motion } from "framer-motion";
import GetAQuoteButton from "@components/GetAQuoteButton";
import BannerSideImage from "@assets/images/Low-fidelity-ui-design.avif";
import { TiTick } from "react-icons/ti";
import FrostedContainer from "../../../../components/FrostedContainer";

export const Banner = () => {
  return (
    <>
      <Head>
        <title>Web App Development for Virginia Startups & SMBs | Apptalyst
        </title>
        <meta
          name="description"
          content="Build scalable web apps with dynamic data feeds. We help small businesses with AI code cleanup, legacy software modernization and custom web app implementation."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/web-app-development"
        />
      </Head>
      <CustomBanner
        bgImg={BannerImage} 
                    customHeight={true}
        className="h-full  "
        BannerImageAlt="Web app portal"
       >
                          <FrostedContainer>            

          <motion.h1
            initial={{ opacity: 0, y: 40 }} 
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[31px] lg:text-[35px] xl:text-[40px] 2xl:text-[50px] leading-[1.2] font-bold  "
          >
Custom Web App Development: Building Feature-Rich Solutions with Dynamic Data Feeds          </motion.h1>
          <div>
            <p className="text-base leading-[1.625rem] font-semibold text-white ">
              We build web apps designed for endless customization, interactive engagement and high-performance. Whether you are scaling a startup, or modernizing enterprise systems, our architecture ensures your web application grows alongside your vision. 
            </p>
          </div>
                     </FrostedContainer>            
      </CustomBanner>
    </>
  );
};
